import IconMeter from '@assets/icons/meter.svg?react';
import IconMoon from '@assets/icons/moon.svg?react';
import IconNav from '@assets/icons/nav.svg?react';
import IconSettings from '@assets/icons/settings.svg?react';
import IconSun from '@assets/icons/sun.svg?react';
import {
 AppBar,
 Box,
 IconButton,
 Typography,
 Toolbar,
 useColorScheme,
 useTheme,
 Theme,
} from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../redux/hooks';
import type { RootState } from '../../../redux/store';
import layoutSizes from '../../../utils/layoutSizes';
import UserWidget from './UserWidget';
import RoleChecker from '../RoleChecker';

const Header = ({
 isMenuSidebarOpen,
 setIsMenuSidebarOpen,
}: {
 isMenuSidebarOpen: boolean;
 setIsMenuSidebarOpen: Dispatch<SetStateAction<boolean>>;
}) => {
 const { mode, systemMode, setMode } = useColorScheme();
 const resolvedMode = mode === 'system' ? systemMode : mode;
 const theme = useTheme();
 const navigate = useNavigate();
 const headerTitle = useAppSelector(
  (state: RootState) => state.header.headerTitle,
 );

 return (
  <AppBar
   elevation={0}
   position="fixed"
   sx={{
    height: layoutSizes.headerHeight,
    width: isMenuSidebarOpen
     ? { xs: '100%', md: `calc(100% - ${layoutSizes.sidebarWidth}px)` }
     : { xs: '100%', md: 'calc(100% - 76px)' },
    ml: isMenuSidebarOpen
     ? { xs: 0, md: `${layoutSizes.sidebarWidth}px` }
     : { xs: '0px', md: '76px' },
    boxShadow: 'none',
    background: theme.palette.kemek.bg2,
    borderBottom: `1px solid ${theme.palette.kemek.lightestGray}`,
   }}
  >
   <Toolbar sx={{ height: '100%' }}>
    <IconButton
     size="large"
     edge="start"
     color="inherit"
     aria-label="menu"
     sx={{ mr: 2, width: 44, height: 44 }}
     onClick={() => setIsMenuSidebarOpen((prevState) => !prevState)}
    >
     <IconNav style={{ color: theme.palette.kemek.darkestGray }} />
    </IconButton>

    <Typography
     component="h1"
     sx={{
      fontSize: 16,
      fontWeight: 500,
      color: (theme: Theme) => theme.palette.kemek.darkestGray,
     }}
    >
     {headerTitle}
    </Typography>

    {/* <Search /> */}
    <Box
     sx={{
      gap: { xs: '24px', md: '32px' },
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
     }}
    >
     {/* <Box>localStorage: {lsSize()}</Box> */}
     <IconButton
      size="large"
      sx={{ p: '4px', height: 24, display: { xs: 'block', md: 'none' } }}
      edge="start"
      color="inherit"
      aria-label="menu"
     >
      <IconMeter />
     </IconButton>
     {/* <Box
						sx={{
							display: { xs: 'none', md: 'flex' },
							alignItems: 'center',
							gap: '20px',
						}}
					>
						<ScalesWidget />
						<ScalesWidget />
					</Box> */}
     <UserWidget />
     <IconButton
      onClick={() => setMode(resolvedMode === 'dark' ? 'light' : 'dark')}
      size="large"
      sx={{
       p: '0px',
       width: 24,
       height: 24,
       ml: 0,
       display: { xs: 'none', md: 'flex' },
      }}
      edge="start"
      color="inherit"
      aria-label="toggle color mode"
     >
      {resolvedMode === 'dark' ? (
       <IconSun
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      ) : (
       <IconMoon
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      )}
     </IconButton>
     <RoleChecker resource="Users" action="GetAll">
      <IconButton
       onClick={() => navigate('/admin/users')}
       size="large"
       sx={{
        p: '0px',
        width: 24,
        height: 24,
        ml: 0,
        display: { xs: 'none', md: 'flex' },
       }}
       edge="start"
       color="inherit"
       aria-label="open admin dashboard"
      >
       <IconSettings
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      </IconButton>
     </RoleChecker>
    </Box>
   </Toolbar>
  </AppBar>
 );
};

export default Header;
